import isEqual from 'lodash/isEqual'
import { toJS } from 'mobx'
import { FIELD_CONFIG } from '../../constants'
import { cameraRotateList } from '../constants'

// 处理视频提交数据
export const formatMerchaniseItems = value => {
  const merchandise_items = []
  if (value.cover_video && value.cover_video.link) {
    merchandise_items.push({
      media_path: value.cover_video.link,
      kind: 2, // 1：图片  2：视频
      persistent_id: value.cover_video.persistent_id,
      cover_path: value.cover_video.cover_path,
      width: value.cover_video.width,
      height: value.cover_video.height,
      is_head: 1
    })
  }
  return merchandise_items
}

// 数据处理 丢utils
export const formatSetMealDetail = value => {
  return (value.case_content || []).map(item => {
    const { type, id } = item
    let content = {}
    switch (type) {
      case 'img':
        content = {
          kind: 1,
          id: id,
          content: {
            media_path: item.link,
            text: item.text,
            width: item.width,
            height: item.height
          }
        }
        break

      case 'video':
        content = {
          kind: 2,
          persistent_id: item.persistent_id,
          id: item.id,
          content: {
            media_path: item.link,
            text: item.text,
            cover_path: item.cover_path,
            width: item.width,
            height: item.height
          }
        }
        break
      case 'title':
        content = {
          kind: 3,
          id: item.id,
          content: {
            title: item.title,
            text: item.text
          }
        }
        break
    }
    return content
  })
}

/**
 * @title 处理setMealItems数据提交格式
 */
export const formatSetMealItems = (
  value,
  property_id,
  cityName,
  spotName,
  spotId
) => {
  let set_meal_items = []
  if (FIELD_CONFIG[property_id]) {
    set_meal_items = FIELD_CONFIG[property_id].map(item => {
      const field = {
        name: item.title,
        describe: ''
      }
      if (item.type == 'date') {
        field['describe'] = value[item.title]
          ? value[item.title].format('YYYY-MM-DD')
          : ''
      } else if (item.type == 'text') {
        field['describe'] = value[item.title] ? value[item.title] : ''
      }
      return field
    })
    // 婚策类型添加
  } else if (property_id == 2) {
    const caseReference = value.caseReference
    set_meal_items = [
      {
        name: '婚礼日期',
        describe:
          value['wedding_date'] && value['wedding_date'].format('YYYY-MM-DD')
      },
      {
        name: '婚礼地点',
        describe: value['hotel_name'],
        merchant_id: value['hotel_id']
      },
      {
        name: '参考价格',
        describe: caseReference
      }
    ]
  }

  if (property_id == 6) {
    let city = cityName && cityName[1]
    let params = [
      {
        name: '拍摄城市',
        describe: city ? city : ''
      },
      {
        name: '拍摄景点',
        describe: city && spotId + '' ? spotName : ''
      }
    ]
    set_meal_items = set_meal_items.concat(params)
  }

  return set_meal_items
}

/**
 * @title 判断form表单的值是否修改改：true：改变；false：未改。value为提交值
 */
export const isChange = (
  new_tag_ids,
  case_detail,
  isChanged,
  selectedTopWeddingTag,
  selectedTopWeddingTagFrozen
) => {
  let flag = isChanged
  // 对比案例属性
  const tagIds = case_detail.tags.map(item => item.mark_id)
  if (JSON.stringify(new_tag_ids) != JSON.stringify(tagIds)) {
    flag = true
  }

  // 对比高定标签
  if (
    !isEqual(toJS(selectedTopWeddingTag), toJS(selectedTopWeddingTagFrozen))
  ) {
    flag = true
  }
  return flag
}

/**
 * @description 处理提交的图片和视频格式
 */
export const formatImageVideo = arr => {
  if (!arr || !arr.length) {
    return []
  }
  return arr?.map(e => {
    if (e.type.includes('image')) {
      return {
        type: 1,
        photo: {
          path: e.url,
          width: e.width || e.response?.width,
          height: e.height || e.response?.height
        }
      }
    } else {
      return {
        type: 2,
        video: {
          path: e.url,
          width: e.width || e.response?.avinfo?.video?.coded_width,
          height: e.height || e.response?.avinfo?.video?.coded_height
        }
      }
    }
  })
}

/**
 * @title 计算案例正文 1视频 2图片 3文本
 */
export const formatCaseContent = (media_items = []) => {
  return media_items.reduce((acc, cur) => {
    const { kind } = cur
    switch (+kind) {
      case 2:
        acc.push({
          link: cur.content.media_path,
          type: getCaseContentType(cur.kind),
          text: cur.content.text,
          persistent_id: cur.persistent_id,
          width: cur.content.width,
          height: cur.content.height,
          id: cur.id,
          cover_path: cur.content.cover_path
        })
        break
      case 1:
        // 老案例 图片带有描述的 需要拿出来 单独存一份文本 @qianze
        if (cur.text) {
          acc.push({
            type: 'title',
            id: cur.id,
            title: '',
            text: cur.text
          })
        }
        acc.push({
          link: cur.content.media_path,
          type: getCaseContentType(cur.kind),
          persistent_id: cur.persistent_id,
          width: cur.content.width,
          height: cur.content.height,
          id: cur.id,
          cover_path: cur.content.cover_path
        })
        break
      case 3:
        const title = (cur.content || {}).title
        const text = (cur.content || {}).text
        if (title || text) {
          acc.push({
            type: 'title',
            id: cur.id,
            title,
            text
          })
        }
        break
    }
    return acc
  }, [])
}

/**
 * @title 寻找城市code和省级
 */
export const findCity = (name, all) => {
  let citycode = ''
  let provice = {}
  const allCity = toJS(all)
  for (let i in allCity) {
    for (let j in allCity[i].children) {
      if (allCity[i].children[j].label == name) {
        citycode = allCity[i].children[j].key
        provice = allCity[i]
      }
    }
  }
  return {
    citycode,
    provice
  }
}

/**
 * @title 案例正文类型
 */
export const getCaseContentType = type =>
  ({ 1: 'img', 2: 'video', 3: 'title' }[+type])

/**
 * @title 校验图片宽度
 */
export const checkImageWidth = ({ width, height, orientation }) => {
  const isRotate = orientation && cameraRotateList.includes(orientation.val)
  const calcHeight = !isRotate ? height : width
  return calcHeight < 8192
}

/**
 * @title 格式化案例详情图片数据格式
 */

export const getImgItem = (link, { width, height, orientation }) => {
  const isRotate = orientation && cameraRotateList.includes(orientation.val)
  return {
    type: 'img',
    link,
    width: !isRotate ? width : height,
    height: !isRotate ? height : width
  }
}
